import {getRouteApi} from "@tanstack/react-router";

export const offerTemplateNotesRouteApi = getRouteApi(
  "/_app/sales/offers/templates/$offerTemplateId/notes/",
);
